import { FC } from 'react';
import { Button } from '@/components/ui/button';
import { AlexaDevice } from '@/types/device';

export type SelectedDevicesActionBarProps = {
  selectedDevices: AlexaDevice[];
  linkDeviceButtonText?: string;
  onLinkDevicesClick: () => void;
};

export const SelectedAlexaDevicesActionBar: FC<
  SelectedDevicesActionBarProps
> = ({
  selectedDevices = [],
  linkDeviceButtonText = 'Import device',
  onLinkDevicesClick,
}) => {
  if (selectedDevices.length === 0) {
    return null;
  }

  return (
    <div className="mb-5 flex flex-row items-center justify-between gap-4 rounded-lg bg-gray-800 p-4">
      <div className="w-20 text-sm font-semibold text-white">{`${selectedDevices.length} selected`}</div>
      <div className="flex gap-2">
        <Button onClick={onLinkDevicesClick} variant="secondary">
          {linkDeviceButtonText}
        </Button>
      </div>
    </div>
  );
};
